











import { Component, Prop, Vue } from 'vue-property-decorator'
import { UTF8Payload } from 'avalanche/dist/utils'

@Component
export default class UtfPayloadView extends Vue {
    @Prop() payload!: UTF8Payload
    isText = false

    $refs!: {
        view: HTMLElement
        text: HTMLElement
    }

    mouseEnter() {
        this.showText()
    }

    mouseLeave() {
        this.isText = false
    }

    showText() {
        const pos: HTMLElement = this.$refs.view
        const rect = pos.getBoundingClientRect()

        this.$refs.text.style.top = rect.y + rect.height + 'px'
        this.$refs.text.style.left = rect.x + 'px'
        this.isText = true
    }

    get text() {
        return this.payload.getContent()
    }
}
